<script setup lang="ts">
import { breakpointsTailwind } from '@vueuse/core'
import type { MenuItem } from '@/composables/layout'

import PromptLibraryMenu from '~/components/App/NewHeader/PromptLibraryMenu/index.vue'
import DesktopAppMenu from '~/components/App/NewHeader/DesktopAppMenu/index.vue'
import TheDailyBiteMenu from '~/components/App/NewHeader/TheDailyBite/index.vue'

const { colors } = useTheme()
const openMenuState = useHeaderMenusActive()

const breakpoints = useBreakpoints(breakpointsTailwind)
const isMobile = breakpoints.smaller('md')

function handleItemHover(item: MenuItem) {
  if (isMobile.value)
    return

  openHeaderMenu(item)
}
</script>

<template>
  <button center gap="2px" @click="toggleHeaderMenu('promptLibrary')" @mouseenter="handleItemHover('promptLibrary')">
    <Text :color="openMenuState.promptLibrary ? colors.softBlack : colors.bluishDarker" :bold="openMenuState.promptLibrary">
      Prompt Library
    </Text>
    <div
      i-mdi:chevron-down
      duration-125
      :style="{
        transform: openMenuState.promptLibrary ? 'rotate(-180deg)' : '',
      }"
    />
  </button>
  <PromptLibraryMenu v-if="isMobile" />

  <button center gap="2px" @click="toggleHeaderMenu('desktopApp')" @mouseenter="handleItemHover('desktopApp')">
    <Text :color="openMenuState.desktopApp ? colors.softBlack : colors.bluishDarker" :bold="openMenuState.desktopApp">
      Desktop App
    </Text>
    <div
      i-mdi:chevron-down
      duration-125
      :style="{
        transform: openMenuState.desktopApp ? 'rotate(-180deg)' : '',
      }"
    />
  </button>
  <DesktopAppMenu v-if="isMobile" />

  <button center gap="2px" @click="toggleHeaderMenu('theDailyBite')" @mouseenter="handleItemHover('theDailyBite')">
    <Text :color="openMenuState.theDailyBite ? colors.softBlack : colors.bluishDarker" :bold="openMenuState.theDailyBite">
      The Daily Bite
    </Text>
    <div
      i-mdi:chevron-down
      duration-125
      :style="{
        transform: openMenuState.theDailyBite ? 'rotate(-180deg)' : '',
      }"
    />
  </button>
  <TheDailyBiteMenu v-if="isMobile" />

  <!-- <button center gap="2px" @click="toggleHeaderMenu('plugins')" @mouseenter="handleItemHover('plugins')">
    <Text :color="openMenuState.plugins ? colors.softBlack : colors.bluishDarker" :bold="openMenuState.plugins">
      Plugins
    </Text>
    <div
      i-mdi:chevron-down
      duration-125
      :style="{
        transform: openMenuState.plugins ? 'rotate(-180deg)' : '',
      }"
    />
  </button>
  <PluginsMenu v-if="isMobile" /> -->
</template>
